<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <!--  Begin: List Card -->

        <!-- Begin: Page Option -->
        <div class="row">
          <div class="col-sm-12 text-right">
            <right-panel
              class="float-right"
              id="sidebar-asset-group-category-asset-group-pair"
              width="400px"
              :icon="'mdi mdi-plus'"
              :text="$t('common.add')"
              @hidden="rightPanelClosed"
            >
              <div class="pl-5 pr-5">
                <Form :state="state" :hide-library="true" @onSave="multipleSave" />
              </div>
            </right-panel>
          </div>
        </div>
        <!-- End: Page Option -->

        <!-- Begin: Table -->

        <div class="bg-white">
          <table class="table table-bordered table-striped">
            <thead class="bg-secondary text-white">
              <tr>
                <th style="width: 100px">
                  <b-dropdown split :text="$t('common.select-all')" class="btn-block" variant="secondary" size="sm" @click="selectAllItems">
                    <template #button-content>
                      <b> {{ selectedItems.length > 0 ? $t("common.deselect-all") : $t("common.select-all-items") }}</b>
                    </template>
                    <b-dropdown-item href="#" @click="multipleDeleteById(selectedItems)" :disabled="!isAtLeastOneItemSelected">
                      <i class="bx bx-trash-alt text-danger" v-b-tooltip.hover :title="$t('common.delete')"></i> {{ $t("common.delete") }} ({{ selectedItems.length }})
                    </b-dropdown-item>
                    <!-- <b-dropdown-item href="#" @click="openModal()" :disabled="!isAtLeastOneItemSelected">
                      <i class="mdi mdi-plus-box-multiple text-primary" v-b-tooltip.hover :title="$t('common.add')"></i> {{ $t("common.add") }} ({{ selectedItems.length }})
                    </b-dropdown-item> -->
                  </b-dropdown>
                </th>
                <th>{{ $t("product.text") }}</th>
                <th>{{ $t("asset-group-category.text") }}</th>
                <th>{{ $t("common.type") }}</th>
                <th scope="col" style="width: 15%">
                  <a href="javascript:;" @click="toggleFilter">
                    <span v-if="filterEnabled" class="text-warning">
                      <i class="bx bxs-filter-alt"></i>
                      {{ $t("common.filters-hide") }}
                    </span>
                    <span v-else class="text-white">
                      <i class="bx bxs-filter-alt"></i>
                      {{ $t("common.filters-show") }}
                    </span>
                  </a>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-if="filterEnabled">
                <th></th>
                <th></th>
                <th>
                  <filter-select
                    id="assetGroupCategoryFilter"
                    ref="assetGroupCategoryFilter"
                    :placeholder="$t('assetGroupCategory.text')"
                    :multiple="false"
                    @filter="onAssetGroupCategorySearch"
                    @changed="onAssetGroupCategorySelect"
                  />
                </th>

                <th></th>
              </tr>
              <template v-if="pagination">
                <tr v-for="item in pagination.docs" :key="item._id">
                  <td>
                    <div class="text-center">
                      <b-form-checkbox v-if="isCompatibleWithScope(item)" v-model="selectedItems" :value="item" class="custom-checkbox-primary mb-3 " checked></b-form-checkbox>
                    </div>
                  </td>
                  <td>
                    <span v-if="item.products">
                      {{ item.products.join(", ") }}
                    </span>
                  </td>
                  <td>
                    <span v-if="item.assetGroupCategory">
                      {{ item.assetGroupCategory.name | translate }}
                    </span>
                  </td>
                  <td>
                    <span v-if="item.scope && isWorkspaceScopedItem(item)">{{ item.scope.value }}</span>
                    <span v-else>{{ $t("common.system") }}</span>
                  </td>
                  <td>
                    <div v-if="isCompatibleWithScope(item)" class="font-size-16 text-center">
                      <i class="bx bx-pencil text-primary hand" v-b-tooltip.hover :title="$t('common.edit')" @click="edit(item)"></i>
                      <i class="bx bx-trash text-danger hand ml-2" v-b-tooltip.hover :title="$t('common.edit')" @click="remove(item)"></i>
                    </div>
                  </td></tr
              ></template>
            </tbody>
          </table>
          <content-loading class="text-center" v-if="isLoading" />
        </div>
        <!-- End: Table -->

        <!-- Begin: Pagination -->

        <div v-if="pagination" class="row">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
        <!-- End: Pagination -->

        <b-modal id="modal-multiple-delete-operation-assetGroupCategory-assetGroup" centered :title="$t('common.multiple-delete-operation')" hide-footer>
          <div v-if="deleteOperationResult">
            <div v-if="deleteOperationResult.success.length > 0">
              <h5 class="text-success">{{ $t("common.delete-items") }}</h5>
              <ul>
                <li v-for="item in deleteOperationResult.success" :key="item._id">
                  {{ item | translate }}
                </li>
              </ul>
            </div>

            <div v-if="deleteOperationResult.failed.length > 0">
              <h5 class="text-danger mt-4">{{ $t("common.delete-failed") }}</h5>
              <ul>
                <li v-for="item in deleteOperationResult.failed" :key="item._id">
                  <b> {{ item.name | translate }}</b>
                  {{ item.error }}
                </li>
              </ul>
            </div>
          </div>
        </b-modal>

        <b-modal id="assetGroupCategoryAssetGroup" centered :title="$t('assetGroup.add-other-assetGroup')" hide-footer>
          <sweet-button
            @click="multipleSave()"
            type="submit"
            :loading="isUpdating"
            :disabled="isUpdating || $v.$invalid"
            variant="success"
            icon="mdi mdi-check"
            size="sm"
            buttonClass="mt-2"
          >
            {{ $t("common.save") }}
          </sweet-button>
        </b-modal>

        <b-modal id="modal-multiple-save-product-asset-group-category" centered :title="$t('common.multiple-add-operation')" hide-footer>
          <div v-if="Object.keys(success).length > 0">
            <h5 class="text-success mt-4">{{ $t("common.added") }}</h5>
            <ul>
              <li v-for="key in Object.keys(success)" :key="key">
                <b> {{ success[key][0].assetGroupCategory.name | translate }}</b>
                <ol>
                  <li v-for="i in success[key]" :key="i">{{ i.product }}</li>
                </ol>
              </li>
            </ul>
          </div>

          <div v-if="Object.keys(fail).length > 0">
            <h5 class="text-danger mt-4">{{ $t("common.not-added") }}</h5>
            <ul>
              <li v-for="key in Object.keys(fail)" :key="key">
                <b> {{ fail[key][0].assetGroupCategory.name | translate }}</b>
                <ol>
                  <li v-for="i in fail[key]" :key="i">{{ i.product }}</li>
                </ol>
              </li>
            </ul>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import FilterSelect from "@c/form/filter-select";
import RightPanel from "@c/right-panel";
import { required } from "vuelidate/lib/validators";
import Form from "./product-asset-group-category-form";

const state = "productAssetGroupCategory";
export default {
  components: {
    RightPanel,
    FilterSelect,
    Form,
  },
  props: ["state"],
  data() {
    return {
      form: { products: [], assetGroupCategory: undefined },
      request: {
        options: { page: 1, limit: 15, sort: { ...(this.state === "workspaceProductAssetGroupCategory" ? { "scope.workspace": "desc" } : { "scope.workspace": "asc" }) } },
        query: {},
      },

      filterEnabled: false,
      selectedItems: [],
      success: {},
      fail: {},
    };
  },
  validations: {
    form: {
      assetGroup: {
        required,
      },
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.init());
      },
    },
  },
  mounted() {
    this.state = this.state || state;
  },
  computed: {
    isWorkspaceLayout() {
      return this.state === "workspaceProductAssetGroupCategory";
    },
    pagination() {
      return this.$store.getters[`${this.state}/pagination`];
    },
    isLoading() {
      return this.$store.getters[`${this.state}/isLoading`];
    },
    isAtLeastOneItemSelected() {
      return this.selectedItems.length > 0;
    },
    deleteOperationResult() {
      return this.$store.getters[`${this.state}/deleteOperationResult`];
    },
    isUpdating() {
      return this.$store.getters[`${this.state}/isUpdating`];
    },
  },
  methods: {
    isCompatibleWithScope(item) {
      return (this.isWorkspaceLayout && this.isWorkspaceScopedItem(item)) || (!this.isWorkspaceLayout && !this.isWorkspaceScopedItem(item));
    },
    isWorkspaceScopedItem(item) {
      return item.scope?.value == "workspace";
    },
    init() {
      this.$store.dispatch(`${this.state}/paginate`, this.request);
    },
    selectAllItems() {
      if (this.selectedItems.length > 0) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.pagination.docs.slice();
        if (this.state === "workspaceProductAssetGroupCategory") {
          this.selectedItems = this.selectedItems.filter((i) => i.scope?.value == "workspace");
        }
      }
    },

    async onAssetGroupCategorySearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceAssetGroupCategory" : "managementAssetGroupCategory";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onAssetGroupCategorySelect(item) {
      if (item && Object.keys(item).length) {
        this.request.query = {
          ...this.request.query,
          assetGroupCategory: item._id,
        };
      } else {
        this.request.query["assetGroupCategory"] = null;
        delete this.request.query["assetGroupCategory"];
      }
    },

    rightPanelClosed() {
      this.$store.commit(`${this.state}/editedEntity`, null);
      this.init();
    },
    edit(item) {
      this.$store.commit(`${this.state}/editedEntity`, { ...item });
      this.$root.$emit("bv::toggle::collapse", "sidebar-asset-group-category-asset-group-pair");
    },
    async multipleDeleteById(selectedItems) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${this.state}/multipleDelete`, selectedItems);
        this.init();
        this.selectedItems = [];
        this.$root.$emit("bv::toggle::modal", "modal-multiple-delete-operation-asset-group-category-asset-group");
      } catch (error) {
        console.error(error);
      }
    },
    async remove(record) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${this.state}/delete`, record._id);
        this.init();
        this.$toast.success("'" + this.$options.filters.translate(record.assetGroupCategory.name) + "-" + record.products.join(",") + "'  " + this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, {
          customMessage: "'" + this.$options.filters.translate(record.assetGroupCategory.name) + "-" + record.products.join(",") + "' " + this.$t("common.could-not-delete"),
        });
      }
    },
    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
    },
    openModal() {
      this.$root.$emit("bv::toggle::modal", "assetGroupCategoryAssetGroup");
    },
    assetGroupSelect(item) {
      this.form = { ...this.form, assetGroup: item };
    },

    async multipleSave(_id, products, assetGroupCategories) {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      this.fail = {};
      this.success = {};

      if (assetGroupCategories) {
        this.selectedItems = assetGroupCategories;
      }

      let requestedItems = [];

      if (!Array.isArray(this.selectedItems)) {
        this.selectedItems = [this.selectedItems];
      }
      for (const item of this.selectedItems) {
        const assetGroupCategory = item.assetGroupCategory ?? item;
        if (requestedItems.includes(assetGroupCategory._id)) {
          continue;
        }
        let productList = this.form.products;
        if (products) {
          productList = products;
        }

        try {
          if (!Array.isArray(productList)) {
            productList = [productList];
          }
          for (const product of productList) {
            try {
              await this.$store.dispatch(`${this.state}/save`, { _id, assetGroupCategory, products: productList });

              if (this.success[assetGroupCategory._id]) {
                this.success[assetGroupCategory._id].push({ product, assetGroupCategory });
              } else {
                this.success[assetGroupCategory._id] = [{ product, assetGroupCategory }];
              }
            } catch (error) {
              if (this.fail[assetGroupCategory._id]) {
                this.fail[assetGroupCategory._id].push({ product, assetGroupCategory });
              } else {
                this.fail[assetGroupCategory._id] = [{ product, assetGroupCategory }];
              }
            }
            requestedItems.push(assetGroupCategory._id);
          }
        } catch (e) {
          console.error(e);
        }
      }

      this.init();
      this.selectedItems = [];

      this.$root.$emit("bv::toggle::modal", "modal-multiple-save-product-asset-group-category");

      if (!assetGroupCategories || !products) {
        this.$root.$emit("bv::toggle::modal", "assetGroupCategoryAssetGroup");
      }
      this.rightPanelClosed();
    },
  },
};
</script>
